module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"createWebGIS":"Create Web GIS"},"ru":{"createWebGIS":"Создать Веб ГИС"}}')
  delete Component.options._Ctor
}
